import React from "react";
import { useTranslation } from "react-i18next";
import { useParallax } from "react-scroll-parallax";

import { SectionIds } from "@constants/sectionIds";
import InfoCard from "@components/common/InfoCard/InfoCard";

import useSkeyPoapData from "./useSkeyPoapData";

import "./SkeyPoap.scss";

const SkeyPoap = () => {
  const { t } = useTranslation(["landingPage"]);
  const data = useSkeyPoapData();

  const { ref } = useParallax({ speed: 15, scale: [1.05, 1, "easeOutCubic"] });

  return (
    <section id={SectionIds.SkeyPoap} className="skey-poap">
      <img
        ref={ref as any}
        src="/images/layouts/bubble-paralax.png"
        alt="background paralax"
        className="skey-poap-paralax"
      />

      <div className="skey-poap-main">
        <div className="main-content">
          <h2>{t("landingPage:skeyPoap.title")}</h2>
          <p className="p0 mt-8 white-space-pre-wrap">{t("landingPage:skeyPoap.description")}</p>
        </div>

        <div className="main-schema-box">
          <img src="/images/layouts/skey-poap-schema.svg" alt="Skey Poap schema" className="image-schema" />
        </div>
      </div>

      <div className="skey-poap-cards">
        {data.map(({ img, description }, index) => (
          <InfoCard key={index} imgSrc={img.src} imgAlt={t(img.alt as any)} description={t(description as any)} />
        ))}
      </div>
    </section>
  );
};

export default SkeyPoap;
